// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"cc5bbf41","977":"5b58dcc6"}[chunkId] + ".chunk.js";
};